import React from 'react';

interface MatchRoleBadgeProps {
  creatorId?: string;
  currentUserId: string;
  players?: Array<{ userId?: string }>;
  size?: 'sm' | 'md';
}

const sizeStyles = {
  sm: { padding: '2px 8px', fontSize: 11 },
  md: { padding: '4px 10px', fontSize: 13 },
};

const variantColors = {
  organizer: {
    background: 'rgba(255, 193, 7, 0.15)',
    border: 'rgba(255, 193, 7, 0.4)',
    color: '#FFC107',
  },
  player: {
    background: 'rgba(0, 200, 83, 0.15)',
    border: 'rgba(0, 200, 83, 0.4)',
    color: '#00C853',
  },
};

export default function MatchRoleBadge({
  creatorId,
  currentUserId,
  players = [],
  size = 'sm',
}: MatchRoleBadgeProps) {
  if (!currentUserId) return null;

  const isOrganizer = creatorId && creatorId === currentUserId;
  const isPlayer = !isOrganizer && players.some((p) => p.userId === currentUserId);

  if (!isOrganizer && !isPlayer) return null;

  const variant = isOrganizer ? variantColors.organizer : variantColors.player;
  const label = isOrganizer ? '👑 Organizador' : '⚽ Jugador';
  const sz = sizeStyles[size];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: variant.background,
        border: `1px solid ${variant.border}`,
        color: variant.color,
        borderRadius: 999,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        ...sz,
      }}
    >
      {label}
    </span>
  );
}
